<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconSpeakerOn_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <g clip-path="url(#IconSpeakerOn_16__a)">
        <path
            fill="currentColor"
            fill-rule="evenodd"
            d="M11.953 1.878a.599.599 0 0 1 .837-.135A7.75 7.75 0 0 1 16 8a7.746 7.746 0 0 1-3.21 6.257.599.599 0 1 1-.702-.972A6.542 6.542 0 0 0 14.8 8a6.542 6.542 0 0 0-2.712-5.285.6.6 0 0 1-.135-.837ZM6.833 2a.666.666 0 0 0-.533.267L4.029 5.294l-2.189.438C1.061 5.888.5 6.572.5 7.366v1.267c0 .794.561 1.478 1.34 1.634l2.19.438 2.27 3.028a.666.666 0 0 0 1.2-.4V2.667A.666.666 0 0 0 6.833 2Zm3.322 1.993a.6.6 0 0 0-.51 1.087A3.245 3.245 0 0 1 11.514 8a3.245 3.245 0 0 1-1.869 2.92.6.6 0 0 0 .509 1.087A4.448 4.448 0 0 0 12.714 8a4.448 4.448 0 0 0-2.559-4.007Z"
            clip-rule="evenodd"
        />
    </g>
    <defs>
        <clipPath id="IconSpeakerOn_16__a">
            <path fill="currentColor" d="M0 0h16v16H0z" />
        </clipPath>
    </defs>
</svg>
